import {
  IconBell,
  IconBinocularsGray,
  IconChainLink,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/constructionSop/img/1.avif';
import image2 from '@src/assets/images/solution/constructionSop/img/2.avif';
import image3 from '@src/assets/images/solution/constructionSop/img/3.avif';
import image4 from '@src/assets/images/solution/constructionSop/img/4.avif';
import image5 from '@src/assets/images/solution/constructionSop/img/5.avif';
import image6 from '@src/assets/images/solution/constructionSop/img/6.avif';
import image7 from '@src/assets/images/solution/constructionSop/img/7.avif';
import image8 from '@src/assets/images/solution/constructionSop/img/8.avif';

export default {
  type: 'Giải pháp Xây dựng',

  banner: {
    title: 'Phát hiện nguy hiểm tự động và phản ứng kịp thời',
    desc: 'Hệ thống phát hiện nguy hiểm tại hiện trường theo SOP (Quy trình thao tác chuẩn) và tự động phản ứng. Tất cả lịch sử được lưu trữ dưới dạng dữ liệu, có thể sử dụng làm minh chứng cho kiểm toán và báo cáo. Công nghệ số giúp quản lý an toàn hiệu quả và ngăn ngừa tai nạn từ trước.',
  },

  video: {
    title: 'Tự động phát hiện tai nạn và phản ứng nhanh dựa trên quy trình chuẩn hóa',
    desc: 'Phát hiện chuyển động của công nhân và các yếu tố nguy hiểm theo thời gian thực, tự động kết nối cảnh báo, ghi nhận và phản ứng theo SOP để thực hiện các biện pháp an toàn một cách hệ thống. Dữ liệu được lưu tự động, hữu ích cho phân tích và kiểm toán sau này.',
    play: mainVideo,
  },

  func: [
    {
      theme: 'Phát hiện nguy hiểm tự động và phản ứng thời gian thực',
      title: 'Nhận diện nguy hiểm tự động dựa trên SOP',
      desc: 'Phân tích hành động của công nhân và môi trường xung quanh để tự động phát hiện công việc không tuân thủ SOP, đồng thời xác định dấu hiệu bất thường dựa trên AI.',
      sub1: 'Độ chính xác cao',
      icon1: IconRulerGray,
      sub2: 'Nắm bắt tình hình thời gian thực',
      icon2: IconClockGray,
      image: image1,
    },
    {
      title: 'Tự động hiển thị bảng SOP khi phát hiện nguy hiểm',
      desc: 'Khi sự kiện nguy hiểm xảy ra, quy trình SOP phù hợp với loại công việc sẽ tự động hiển thị. Người phản ứng có thể bắt đầu quy trình chỉ bằng một nút bấm, giúp tận dụng thời gian vàng.',
      sub1: 'Tích hợp dữ liệu nhanh',
      icon1: IconTvocGray,
      sub2: 'Theo dõi vị trí thời gian thực',
      icon2: IconBinocularsGray,
      image: image2,
    },
    {
      title: 'Gọi CCTV và lưu lịch sử xem tự động',
      desc: 'Tự động gọi hình ảnh CCTV của khu vực xảy ra nguy hiểm, toàn bộ lịch sử xem và thời gian sẽ được lưu tự động. Có thể sử dụng ngay để điều tra tai nạn hoặc làm minh chứng pháp lý.',
      sub1: 'Theo dõi vị trí thời gian thực',
      icon1: IconBinocularsGray,
      sub2: 'Độ chính xác cao',
      icon2: IconRulerGray,
      image: image3,
    },
    {
      title: 'Hỗ trợ tham gia SOP qua thiết bị di động',
      desc: 'Không cần PC, quản lý bên ngoài hoặc người phụ trách đang di chuyển vẫn có thể tham gia quy trình SOP bằng điện thoại, đảm bảo phản ứng kịp thời. Có thể tiếp tục xử lý mà không bị giới hạn không gian.',
      sub1: 'Thiết lập phạm vi linh hoạt',
      icon1: IconZoneGray,
      sub2: 'Thiết lập nhiều khu vực',
      icon2: IconTagGray,
      image: image4,
    },
    {
      theme: 'Vận hành SOP và quản lý tùy chỉnh',
      title: 'Hiển thị trạng thái phản ứng theo SOP',
      desc: 'Hiển thị bước hiện tại và tình trạng hoàn thành của từng kịch bản SOP trên bảng điều khiển, giúp nắm bắt luồng phản ứng tổng thể dễ dàng. Quản lý có thể phân bổ thêm nhân lực hoặc tài nguyên theo mức độ ưu tiên.',
      sub1: 'Thiết lập phạm vi linh hoạt',
      icon1: IconTagGray,
      sub2: 'Thiết lập nhiều khu vực',
      icon2: IconZoneGray,
      image: image5,
    },
    {
      title: 'Tự động tạo và tải báo cáo',
      desc: 'Tự động tạo báo cáo dựa trên dữ liệu quan trọng như lịch sử phản ứng, thời gian phát cảnh báo và tình trạng hoàn thành. Có thể tải xuống dưới dạng PDF hoặc Excel, giúp tiết kiệm thời gian và nhân lực cho báo cáo tuần/tháng.',
      sub1: 'Độ chính xác cao',
      icon1: IconZoneGray,
      sub2: 'Thiết lập nhiều khu vực',
      icon2: IconTagGray,
      image: image6,
    },
    {
      title: 'Tạo kịch bản cảnh báo theo điều kiện',
      desc: 'Kết hợp các điều kiện như nhiệt độ, khí gas, vị trí, trạng thái hoạt động để tạo quy tắc cảnh báo tùy chỉnh. Cho phép thiết lập trigger phát hiện nguy hiểm tự động kết nối với nhiều cảm biến IoT.',
      sub1: 'Cài đặt nhanh chóng',
      icon1: IconTagGray,
      sub2: 'Thiết lập nhiều khu vực',
      icon2: IconTagGray,
      image: image7,
    },
    {
      title: 'Chỉnh sửa kịch bản SOP và tùy chỉnh cho công trường',
      desc: 'Chỉnh sửa hoặc tạo mới các bước SOP phù hợp với đặc điểm và loại công việc của hiện trường. Giao diện GUI giúp ai cũng dễ dàng thêm/bớt bước và áp dụng trực tiếp.',
      sub1: 'Hiển thị trực quan thời gian thực',
      icon1: IconShareGray,
      sub2: 'Thiết lập nhiều khu vực',
      icon2: IconTagGray,
      image: image8,
    },
  ],

  subfunc: {
    title: 'Chức năng đa dạng',
    desc: 'Đảm bảo an toàn cho công nhân giúp nâng cao hiệu suất và giảm thiểu thiệt hại do tai nạn. ORBRO cung cấp các chức năng tối ưu để bảo vệ công nhân tại công trường. Hệ thống được thiết kế để phản ứng kịp thời khi công nhân tiếp cận khu vực nguy hiểm, xảy ra tai nạn hoặc có nguy cơ từ thiết bị hạng nặng.',

    data: [
      { icon: IconWarning, title: 'Phát hiện rủi ro', desc: 'Cảm biến phát hiện & cảnh báo ngay.' },
      { icon: IconBell, title: 'Tự chạy SOP', desc: 'Rủi ro xảy ra, SOP tự bật.' },
      { icon: IconDashboard, title: 'Giám sát tập trung', desc: 'Xem mọi dữ liệu an toàn.' },
      { icon: IconBell, title: 'Tự gửi cảnh báo', desc: 'SMS/email thông báo tức thì.' },
      { icon: IconRoute, title: 'Liên kết CCTV tự động', desc: 'Sự kiện gọi CCTV tự động.' },
      { icon: IconSearch, title: 'Xử lý bằng di động', desc: 'Chạy SOP bằng điện thoại.' },
      { icon: IconChartRadius, title: 'Hiển thị tiến độ', desc: 'Xem tiến độ SOP trực tiếp.' },
      { icon: IconChainLink, title: 'Thiết lập điều kiện', desc: 'Tùy chỉnh điều kiện cảnh báo.' },
      { icon: IconChartRadius, title: 'Tạo báo cáo tự động', desc: 'Tạo PDF, Excel tự động.' },
      { icon: IconSecurity, title: 'Lưu cho kiểm tra', desc: 'Tự lưu lịch sử để kiểm toán.' },
    ],
  },

  system: {
    title: 'Cấu hình hệ thống',
    img: rtlsSystem,
  },

  productTitle: 'Cấu hình sản phẩm',
  product: [{ tag: 'workerPackage' }, { tag: 'assetPackage' }],

  contents: [{ data: 'constructionAsset' }, { data: 'constructionEquipment' }, { data: 'blogRTLS' }, { data: 'blogMedical' }],
};
